import { merge } from "lodash-es";

const baseCfg = {
  cfg: {
    buttonPoint: 0.3,
    buttonStyle: {
      width: 20,
      height: 20,
      radius: 10,
      cursor: "pointer",
      gap: 5,
    },
    buttonBackground: {
      base: "#ffffff",
      hover: "#ddd",
      click: "#eee",
    },
    iconMaps: {
      // 可以是网络图片
      // delete: deleteIcon,
    },
  },
};

const deleteEdgeOpt = {
  getEvents() {
    return {
      "edge:mouseenter": "onEdgeMouseEnter",
      "edge:click": "onEdgeClick",
      afterupdateitem: "onEdgeUpdated",
    };
  },
  onEdgeClick(ev) {
    const target = ev.target;
    const targetType = target.get("name") || "";
    if (targetType.startsWith("edgeButton:delete")) {
      // 删除按钮的 parent 是 group, group 的 parent 是 edge
      const edge = target.getParent().getParent();
      // 先删除
      this.graph.removeItem(edge.get("item"));
      // 再触发
      this.graph.emit("xEdge:removeItem", ev);
    } else {
      // 前置该条线条
      if (ev.item && !ev.item.destroyed) {
        ev.item.toFront();
      }
    }
  },

  rerenderButton(e) {
    const item = e.item;
    const itemType = item?.getType() ?? "";
    if (itemType === "edge") {
      const group = item.getContainer();
      const hoverGroup = group.find((v) => {
        if (v.get("name") === "edgeButton:group") {
          return true;
        }
      });
      if (hoverGroup) {
        const hoverGroupItems = hoverGroup.get("children");
        const position = item.getKeyShape().getPoint(this.cfg.buttonPoint);
        hoverGroupItems.forEach((item) => {
          // TODO: 坐标不对
          const name = item.get("name");
          if (name === "edgeButton:delete-icon") {
            const imgWidth =
              this.cfg.buttonStyle.width - this.cfg.buttonStyle.gap;
            const imgHeight =
              this.cfg.buttonStyle.height - this.cfg.buttonStyle.gap;
            item.attr({
              x: position.x - imgWidth / 2,
              y: position.y - imgHeight / 2,
            });
          }
          if (name === "edgeButton:delete") {
            item.attr({
              x: position.x - this.cfg.buttonStyle.width / 2,
              y: position.y - this.cfg.buttonStyle.height / 2,
            });
          }
        });
      }
    }
  },
  onEdgeUpdated(ev) {
    this.rerenderButton(ev);
  },

  calcShouldShowHoverButton(ev) {
    if (!this.graph._addingEdgeByDrag && !this.graph._addingEdgeByClick) {
      return true;
    }
  },

  // 还是每次重新生成吧，这样位置是准确的
  onEdgeMouseEnter(e) {
    if (this.calcShouldShowHoverButton()) {
      const { item } = e;
      const group = item.getContainer();
      const position = item.getKeyShape().getPoint(this.cfg.buttonPoint);

      const hoverGroup = group.addGroup({
        name: "edgeButton:group",
        capture: true,
        zIndex: 1000,
      });
      hoverGroup
        .addShape("rect", {
          attrs: {
            width: this.cfg.buttonStyle.width,
            height: this.cfg.buttonStyle.height,
            radius: this.cfg.buttonStyle.radius,
            cursor: this.cfg.buttonStyle.cursor,
            fill: this.cfg.buttonBackground.base,
            lineWidth: 2,
            opacity: 0,
            x: position.x - this.cfg.buttonStyle.width / 2,
            y: position.y - this.cfg.buttonStyle.height / 2,
          },
          capture: true,
          zIndex: 100,
          name: `edgeButton:delete`,
        })
        .animate(
          {
            opacity: 1,
          },
          150,
        );

      const imgWidth = this.cfg.buttonStyle.width - this.cfg.buttonStyle.gap;
      const imgHeight = this.cfg.buttonStyle.height - this.cfg.buttonStyle.gap;
      hoverGroup
        .addShape("image", {
          attrs: {
            opacity: 0,
            img: this.cfg.iconMaps["delete"],
            ...this.cfg.buttonStyle,
            width: imgWidth,
            height: imgHeight,
            x: position.x - imgWidth / 2,
            y: position.y - imgHeight / 2,
          },
          capture: true,
          zIndex: 150,
          name: `edgeButton:delete-icon`,
        })
        .animate(
          {
            opacity: 1,
          },
          150,
        );
      hoverGroup.toFront();
      hoverGroup.sort();
      group.sort();
    }
  },
};

export const getDeleteEdgeOpt = (opt) => {
  return merge({}, deleteEdgeOpt, baseCfg, opt);
};
